var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreguntasFrecuentes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110.55 110.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #ffcf04;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #003893;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1396",
    "data-name": "Trazado 1396",
    className: "cls-1",
    d: "M70.36,13.17C62.05,4.89,50.56.6,38.85,1.42,18.5,2.86,1.31,21.99,1.31,43.19v23.33c0,10.3,5.44,15.74,15.74,15.74h23.31c21.22,0,40.36-17.15,41.79-37.45.84-11.76-3.47-23.3-11.79-31.64M77.66,44.51c-1.27,18.02-18.35,33.25-37.3,33.25h-23.31c-7.78,0-11.24-3.46-11.24-11.24v-23.33C5.81,24.26,21.08,7.19,39.17,5.91c.85-.07,1.7-.1,2.55-.1,19.91,0,36.05,16.16,36.05,36.07,0,.88-.03,1.75-.1,2.63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1397",
    "data-name": "Trazado 1397",
    className: "cls-2",
    d: "M109.24,95.75v-21.25c-.19-12.48-6.42-24.1-16.72-31.16-1.04-.68-2.43-.39-3.11.65-.66,1.01-.41,2.35.57,3.06,9.08,6.21,14.59,16.45,14.76,27.45v21.25c0,7.43-4.89,8.99-8.99,8.99h-21.23c-11.01-.18-21.24-5.68-27.46-14.76-.71-1.02-2.12-1.26-3.13-.54-1,.7-1.25,2.08-.57,3.09,7.07,10.3,18.69,16.53,31.17,16.71h21.23c8.32,0,13.49-5.17,13.49-13.49h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1398",
    "data-name": "Trazado 1398",
    className: "cls-2",
    d: "M44.03,49.66c0-2.04,1.03-3.27,4.26-5.04,6.53-3.59,8.92-11.79,5.33-18.32-1.96-3.56-5.41-6.05-9.41-6.78-7.27-1.31-14.28,3.36-15.87,10.58-.27,1.21.49,2.42,1.7,2.69s2.42-.49,2.69-1.7c0-.03.01-.07.02-.1,1.09-4.84,5.81-7.95,10.69-7.05,4.89.91,8.11,5.61,7.2,10.5-.49,2.65-2.15,4.94-4.51,6.24-2.3,1.27-6.58,3.62-6.58,8.98,0,1.24,1.01,2.25,2.25,2.25s2.25-1.01,2.25-2.25h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1399",
    "data-name": "Trazado 1399",
    className: "cls-2",
    d: "M41.78,59.78c-2.49,0-4.5,2.01-4.5,4.5s2.01,4.5,4.5,4.5,4.5-2.01,4.5-4.5-2.01-4.5-4.5-4.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreguntasFrecuentes);
export default __webpack_public_path__ + "static/media/preguntas_frecuentes.89dfec1a2b1eddb3ce65a1c21b585788.svg";
export { ForwardRef as ReactComponent };